var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',[_c('b-button',{staticClass:"btn btn-light pull-right",on:{"click":_vm.add}},[_vm._v(_vm._s(_vm.Core.Definition.getDefinition('Nouvel établissement')))])],1)],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }